import type { RoundType } from '../types';

export const roundToPrecision = (
    num: number,
    precision = 0,
    type: RoundType = 'math'
): number => {
    const powd = Math.pow(10, precision);
    if (type === 'bank') {
        const x = num * powd;
        const r = Math.round(x);
        const br = Math.abs(x) % 1 === 0.5 ? (r % 2 === 0 ? r : r - 1) : r;
        return br / powd;
    }
    return Math.round(num * powd) / powd;
};
